import { Fingerprint, ShieldCheck, X } from "lucide-react";

type Props = {
  onStart: () => void;
  onDismiss?: () => void;
};

/**
 * Logged-in only promotional banner for identity + SAMT root certificate.
 */
export function IdentityBanner({ onStart, onDismiss }: Props) {
  return (
    <div className="esign-banner" role="region" aria-label="احراز هویت برای امضا">
      <div className="esign-banner-glow" aria-hidden />
      <div className="esign-banner-orb esign-banner-orb-a" aria-hidden />
      <div className="esign-banner-orb esign-banner-orb-b" aria-hidden />
      <div className="esign-banner-body">
        <div className="esign-banner-icon" aria-hidden>
          <ShieldCheck size={22} />
        </div>
        <div className="esign-banner-copy">
          <p className="esign-banner-title">احراز هویت برای امضای اسناد</p>
          <p className="esign-banner-sub">
            یک‌بار احراز کنید و اسناد را سریع‌تر امضا کنید — امکان{" "}
            <span>صدور گواهی امضای مرکز ریشه وزارت صمت</span> نیز فراهم است.
          </p>
        </div>
        <button type="button" className="esign-banner-cta" onClick={onStart}>
          <Fingerprint size={16} aria-hidden />
          شروع
        </button>
        {onDismiss ? (
          <button
            type="button"
            className="esign-banner-dismiss"
            aria-label="بستن"
            onClick={onDismiss}
          >
            <X size={16} />
          </button>
        ) : null}
      </div>
    </div>
  );
}
